import { render } from "./AutomationModalUpdateVersion.vue?vue&type=template&id=0f2713b6&scoped=true"
import script from "./AutomationModalUpdateVersion.vue?vue&type=script&lang=js"
export * from "./AutomationModalUpdateVersion.vue?vue&type=script&lang=js"

import "./AutomationModalUpdateVersion.vue?vue&type=style&index=0&id=0f2713b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2713b6"]])

export default __exports__